/*
  Puspa Furniture — Recently viewed products
  - On product pages: stores the current product handle in localStorage.
  - Everywhere the section is placed: renders the visitor's history
    (excluding the product currently being viewed).
  - Fails silently and stays hidden if storage is unavailable or empty.
*/
(function () {
  'use strict';

  var STORAGE_KEY = 'puspa:recently-viewed';
  var MAX_STORED = 16;

  function readHistory() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list.filter(function (h) { return typeof h === 'string' && h; }) : [];
    } catch (e) {
      return [];
    }
  }

  function writeHistory(list) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(list.slice(0, MAX_STORED)));
    } catch (e) {
      /* private mode / quota — ignore */
    }
  }

  function recordHandle(handle) {
    if (!handle) return;
    var list = readHistory().filter(function (h) { return h !== handle; });
    list.unshift(handle);
    writeHistory(list);
  }

  function formatMoney(cents, currency, locale) {
    try {
      return new Intl.NumberFormat(locale || undefined, {
        style: 'currency',
        currency: currency || 'INR',
        maximumFractionDigits: 0
      }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(0);
    }
  }

  if (window.customElements && !customElements.get('recently-viewed-products')) {
    customElements.define(
      'recently-viewed-products',
      class RecentlyViewedProducts extends HTMLElement {
        connectedCallback() {
          var currentHandle = this.dataset.currentHandle || '';
          if (currentHandle) recordHandle(currentHandle);

          var limit = parseInt(this.dataset.limit, 10) || 8;
          var handles = readHistory()
            .filter(function (h) { return h !== currentHandle; })
            .slice(0, limit);

          if (!handles.length) return; // stays hidden

          var grid = this.querySelector('[data-recent-grid]');
          if (!grid) return;

          var currency = this.dataset.currency;
          var locale = this.dataset.locale;
          var self = this;

          Promise.all(
            handles.map(function (handle) {
              return fetch('/products/' + encodeURIComponent(handle) + '.js')
                .then(function (res) { return res.ok ? res.json() : null; })
                .catch(function () { return null; });
            })
          ).then(function (products) {
            var rendered = 0;
            products.forEach(function (p) {
              if (!p || !p.handle) return;
              var card = document.createElement('a');
              card.className = 'puspa-recent__card';
              card.href = p.url || '/products/' + p.handle;

              var media = document.createElement('div');
              media.className = 'puspa-recent__media';
              if (p.featured_image) {
                var img = document.createElement('img');
                var src = String(p.featured_image);
                img.src = src.indexOf('?') === -1 ? src + '?width=480' : src + '&width=480';
                img.alt = p.title || '';
                img.loading = 'lazy';
                img.width = 480;
                img.height = 480;
                media.appendChild(img);
              }
              card.appendChild(media);

              var title = document.createElement('div');
              title.className = 'puspa-recent__title';
              title.textContent = p.title || '';
              card.appendChild(title);

              var price = document.createElement('div');
              price.className = 'puspa-recent__price';
              var onSale = p.compare_at_price && p.compare_at_price > p.price;
              var priceSpan = document.createElement('span');
              if (onSale) priceSpan.className = 'puspa-recent__price--sale';
              priceSpan.textContent = formatMoney(p.price, currency, locale);
              price.appendChild(priceSpan);
              if (onSale) {
                var compare = document.createElement('span');
                compare.className = 'puspa-recent__price--compare';
                compare.textContent = formatMoney(p.compare_at_price, currency, locale);
                price.appendChild(compare);
              }
              card.appendChild(price);

              grid.appendChild(card);
              rendered++;
            });
            if (rendered > 0) self.removeAttribute('hidden');
          });
        }
      }
    );
  }
})();
